import 'styled-components';
import { DefaultTheme } from 'styled-components';

/**
 * search for the theme
 * default is 'PCP -> pcpTheme'
 *
 * @param themeName
 *      the theme name
 * @returns
 *      the StyledComponents theme
 */
export const getTheme = (themeName: string) => {
    if (themeName && themeName.toUpperCase() === 'BETA') {
        return betaTheme;
    } else if (themeName && (themeName.toUpperCase() === 'PCPV2' || themeName.toUpperCase() === 'PCP')) {
        return pcpV2Theme;
    } else {
        return pcpV2Theme;
    }
};

/** THE DEFAULT THEME DECLARATION */
declare module 'styled-components' {
    export interface DefaultTheme {
        borderRadius: string;
        mainColor: string;
        passiveColor: string;
        selectButton: {
            backgroundColor: string;
            backgroundColorHover: string;
            backgroundColorActive: string;
        };
        button: {
            borderRadius: string;
            boxShadow: string;
            primary: {
                color: string;
                colorHover: string;
                backgroundColor: string;
                backgroundColorHover: string;
                border: string;
                borderColor: string;
                borderColorHover: string;
                borderRadiusTopLeft: string;
                borderRadiusTopRight: string;
                borderRadiusBottomLeft: string;
                borderRadiusBottomRight: string;
            };
            secondary: {
                color: string;
                colorHover: string;
                backgroundColor: string;
                backgroundColorHover: string;
                border: string;
                borderColor: string;
                borderColorHover: string;
                borderRadiusTopLeft: string;
                borderRadiusTopRight: string;
                borderRadiusBottomLeft: string;
                borderRadiusBottomRight: string;
            };
            warning: {
                color: string;
                colorHover: string;
                backgroundColor: string;
                backgroundColorHover: string;
                border: string;
                borderColor: string;
                borderColorHover: string;
                borderRadiusTopLeft: string;
                borderRadiusTopRight: string;
                borderRadiusBottomLeft: string;
                borderRadiusBottomRight: string;
            };
            success: {
                color: string;
                colorHover: string;
                backgroundColor: string;
                backgroundColorHover: string;
                border: string;
                borderColor: string;
                borderColorHover: string;
                borderRadiusTopLeft: string;
                borderRadiusTopRight: string;
                borderRadiusBottomLeft: string;
                borderRadiusBottomRight: string;
            };
            danger: {
                color: string;
                colorHover: string;
                backgroundColor: string;
                backgroundColorHover: string;
                border: string;
                borderColor: string;
                borderColorHover: string;
                borderRadiusTopLeft: string;
                borderRadiusTopRight: string;
                borderRadiusBottomLeft: string;
                borderRadiusBottomRight: string;
            };
        };
        badge: {
            pos: {
                color: string;
                borderColor: string;
            };
            neg: {
                color: string;
                borderColor: string;
            };
        };
        card: {
            borderRadius: string;
            boxShadow: string;
            boxShadowHover: string;
        };
        icon: {
            size: number;
            strokeWidth: number;
            default: {
                color: string;
                backgroundColorHover: string;
            };
            neg: {
                color: string;
                backgroundColorHover: string;
            };
            passive: {
                color: string;
                backgroundColorHover: string;
            };
        };
        font: {
            alertColor: string;
            passiveColor: string;
            highlightColor: string;
            mainColorHover: string;
        };
        navbar: {
            backgroundColor: string;
            boxShadow: string;
        };
        navbutton: {
            default: {
                color: string;
                backgroundColor: string;
                backgroundColorHover: string;
                borderColor: string;
                borderColorHover: string;
            };
            horizontal: {
                colorActive: string;
                colorInactive: string;
                backgroundColorHover: string;
            };
            vertical: {
                colorActive: string;
                colorInactive: string;
                backgroundColorActive: string;
                backgroundColorInactive: string;
                backgroundColorHover: string;
                borderColor: string;
                borderColorHover: string;
            };
        };
        accordionMenu: {
            backgroundColor: string;
        };
        newMessageBadge: {
            backgroundColor: string;
        };
        step: {
            active: string;
            completed: string;
            line: string;
        };
        header: {
            main: {
                backgroundColor: string;
                color: string;
                buttonColor: string;
            };
        };
        sidebar: {
            backgroundImage: string;
            boxShadow: string;
            itemBackground: string;
        };
        tabcontainer: {
            backgroundImage: string;
        };
        modal: {
            borderRadius: string;
            boxShadow: string;
        };
        list: {
            item: {
                backgroundColorHover: string;
                colorHover: string;
                boxShadow: string;
                borderColor: string;
            };
        };
        medication: {
            icon: {
                acceptColor: string;
                rejectColor: string;
                laterColor: string;
                resultAcceptColor: string;
            };
        };
        hint: {
            backgroundColor: string;
        };
        link: {
            color: string;
            colorHover: string;
        };
        input: {
            label: string;
            border: string;
            borderFocus: string;
            boxShadowFocus: string;
        };
        combobox: {
            border: string;
            borderFocus: string;
            boxShadowFocus: string;
            optionBackgroundHover: string;
            optionBackgroundSelected: string;
            optionBackgroundActive: string;
            color: string;
            colorHover: string;
            colorSelected: string;
            colorActive: string;
        };
        calendar: {
            backgroundEven: string;
            backgroundOdd: string;
        };
    }
}

/**
 *
 * ALL THEMES
 *
 * */

/** PCP Theme */
// const pcpColors = {
//     mainColor: '#1b396b',
//     selectButtonActive: 'rgb(163, 193, 233)',

//     darkOrange: '#fabf31',
//     midOrange: '#fbb102',
//     lightOrange: '#fcd581',
//     warningOrange: '#d39e00', //own color
//     warningOrangeBorder: '#c69500', // own color
//     warningOrangeText: '#212529', // own color
//     dateSelectionBackgroundOrange: 'rgb(254,216,110)',
//     dateSelectionFrameOrange: 'rgb(255,165,0)',

//     callGreen: '#4cda64',
//     tickGreen: '#00ca73',
//     lightGreen: '#9ccc65',
//     midGreen: '#689f38',
//     darkGreen: '#33691e',
//     successGreen: '#adcf03', //own color
//     successGreenHover: '#adcf03c2', //own color

//     activeStep: '#fed86e',

//     darkBlue: '#1c3351',
//     darkBlueOp_50: 'rgba(28, 51, 81, .5)',
//     inputBlue: '#415486',
//     textBlue: '#707ea4',
//     cornerBlue: '#BFD3EB',
//     myBlue: '#d7e3f2',
//     extraLightBlue: '#dde3eb',
//     lightBlue: '#F1F2F6',
//     p1: 'rgb(236,242,250)',
//     p2: 'rgb(221,232,247)',
//     p3: 'rgb(205,220,243)',
//     p4: 'rgb(163,193,233)',
//     p5: 'rgb(36,94,173)',

//     callRed: '#ff3b2f',
//     lightRed: '#ff4248',
//     extraLightRed: '#fe5f55',
//     red: 'rgb(192,0,0)',

//     lightGray: 'rgb(245, 245, 245)',
//     lightGrayOp: 'rgba(245, 245, 245, 0.97)',
//     midGray: '#E3E3E3',
//     lightBlack: '#2D2D2D',
//     fontColorGray: 'rgba(116,118,130)',

//     iosPDFbackgroundColor: '#1c1c1e',
//     androidPDFbackgroundColor: '#eeeeee',

//     extralightGray: 'rgba(250, 250, 250, .95)',

//     bloodPressureColor: 'rgb(77,94,196)',
//     bodyTemperatureColor: 'rgb(188,113,96)',
//     oxygenColor: 'rgb(64,167,177)',

//     inactiveColor: 'gray',
//     iconBackgroundColorHover: '#88aedd',

//     accordionMenuBackground: '#e2e6ea',
//     navbarBackground: '#f8f9fa',
//     sidebarBackground: 'linear-gradient(to right top, #1b396b, #1b396b, #1b396b, #1b396b, #1b396b)',
//     tabContainerBackground: 'none',

//     hintBackground: 'rgb(240, 240, 240)',
// };

// const pcpValues = {
//     borderRadius: '4px',
//     buttonBorderRadius: '4px',
//     buttonBoxShadow: 'none',
//     navbarBoxShadow: 'none',
//     sidebarBoxShadow: 'none',
//     modalBorderRadius: '0px',
//     modalBoxShadow: 'none',
//     cardBoxShadow: 'none',
//     cardBoxShadowHover: 'none',
//     cardRadius: '24px',
//     iconSize: 30,
//     strokeWidth: 2,
// };

/** PCP V2 Theme */
const pcpV2Colors = {
    mainColor: '#1b396b',
    selectButtonActive: 'rgb(163, 193, 233)',

    darkOrange: '#fabf31',
    midOrange: '#fbb102',
    lightOrange: '#fcd581',
    warningOrange: '#d39e00', //own color
    warningOrangeBorder: '#c69500', // own color
    warningOrangeText: '#212529', // own color
    dateSelectionBackgroundOrange: 'rgb(254,216,110)',
    dateSelectionFrameOrange: 'rgb(255,165,0)',

    callGreen: '#4cda64',
    tickGreen: '#00ca73',
    lightGreen: '#9ccc65',
    midGreen: '#689f38',
    darkGreen: '#33691e',
    successGreen: '#adcf03', //own color
    successGreenHover: '#adcf03c2', //own color

    activeStep: '#fed86e',

    darkBlue: '#1c3351',
    darkBlueOp_50: 'rgba(28, 51, 81, .5)',
    inputBlue: '#415486',
    textBlue: '#707ea4',
    cornerBlue: '#BFD3EB',
    myBlue: '#d7e3f2',
    extraLightBlue: '#dde3eb',
    lightBlue: '#F1F2F6',
    p1: 'rgb(236,242,250)',
    p2: 'rgb(221,232,247)',
    p3: 'rgb(205,220,243)',
    p4: 'rgb(163,193,233)',
    // p5: 'rgb(36,94,173)',
    p5: 'rgb(27,57,107)',

    callRed: '#ff3b2f',
    lightRed: '#ff4248',
    extraLightRed: '#fe5f55',
    red: 'rgb(192,0,0)',

    lightGray: 'rgb(245, 245, 245)',
    lightGrayOp: 'rgba(245, 245, 245, 0.97)',
    midGray: '#E3E3E3',
    lightBlack: '#2D2D2D',
    fontColorGray: 'rgba(116,118,130)',

    gray_1: '#949494',

    iosPDFbackgroundColor: '#1c1c1e',
    androidPDFbackgroundColor: '#eeeeee',

    extralightGray: 'rgba(250, 250, 250, .95)',

    bloodPressureColor: 'rgb(77,94,196)',
    bodyTemperatureColor: 'rgb(188,113,96)',
    oxygenColor: 'rgb(64,167,177)',

    inactiveColor: 'gray',
    // iconBackgroundColorHover: '#88aedd',
    iconBackgroundColorHover: 'rgb(213 213 215)',

    accordionMenuBackground: '#e2e6ea',
    navbarBackground: 'hsl(210,8%,97.5%)',
    // sidebarBackground: 'linear-gradient(to right top, #1b396b, #144875, #17577c, #256582, #387387)',
    // sidebarBackground: 'linear-gradient(to right bottom, #245dae, #4473bb, #6089c9, #7ba0d6, #97b6e3)',
    sidebarBackground: 'linear-gradient(to right bottom, #2156A1, #2156A1, #2156A1, #2156A1, #2156A1)',
    // tabContainerBackground: 'linear-gradient(to bottom, #1b396b, #144875, #17577c, #256582, #387387)',
    tabContainerBackground: 'linear-gradient(to bottom, #2156A1, #2156A1, #2156A1, #2156A1, #2156A1)',

    hintBackground: 'rgb(240, 240, 240)',

    linkColor: '#39549D',
    linkColorHover: '#2A437F',

    // inputColor: '#8E93A9',
    inputColorLabel: '#53586E',
    inputColorBorder: '#53586E',
    // inputColorBorderFocus: '#747682',
    inputColorBorderFocus: '#9EBCE9',
    inputBoxShadowFocus: '0 0 0 0.2rem rgba(158, 188, 233, 0.70)',

    comboboxOptionHover: '#DDE8F7',
    comboboxOptionSelected: '#EDEEEE',
    comboboxOptionActive: '#CDDCF3',
    comboboxColor: '#495057',
    comboboxColorHover: 'black',
    comboboxColorSelected: '#495057',
    comboboxColorActive: 'black',

    buttonBackgroundHover: 'rgba(36,94,173, 1)',
};

const pcpV2Values = {
    borderRadius: '8px',
    buttonBorderRadius: '24px',
    // buttonBoxShadow: '2px 2px 7px 1px rgb(0 0 0 / 20%)',
    buttonBoxShadow: 'rgba(0, 0, 0, .2) 0 3px 5px -1px,rgba(0, 0, 0, .14) 0 6px 10px 0,rgba(0, 0, 0, .12) 0 1px 18px 0',
    navbarBoxShadow: '0 2px 4px rgb(0 0 0 / 50%)',
    sidebarBoxShadow: '2px 0px 4px rgb(0 0 0 / 50%)',
    modalBorderRadius: '24px',
    modalBoxShadow: '4px 4px 14px 2px rgb(0 0 0 / 20%)',
    cardBoxShadow: '0 2px 4px 0 #e0e1e1, 0 3px 10px 0 #e0e1e1',
    cardBoxShadowHover: '0 4px 8px 0 #e0e1e1, 0 6px 20px 0 #e0e1e1',
    cardRadius: '24px',
    iconSize: 30,
    strokeWidth: 1.5,
};

export const pcpV2Theme: DefaultTheme = {
    borderRadius: pcpV2Values.borderRadius,
    mainColor: pcpV2Colors.mainColor,
    passiveColor: pcpV2Colors.lightGray,
    selectButton: {
        backgroundColor: 'white',
        backgroundColorHover: pcpV2Colors.selectButtonActive,
        backgroundColorActive: pcpV2Colors.selectButtonActive,
    },
    button: {
        borderRadius: pcpV2Values.buttonBorderRadius,
        boxShadow: pcpV2Values.buttonBoxShadow,
        primary: {
            color: 'white',
            colorHover: 'white',
            backgroundColor: pcpV2Colors.buttonBackgroundHover,
            // backgroundColorHover: '#a3c2eaff',
            backgroundColorHover: pcpV2Colors.p5,
            border: 'none',
            borderColor: pcpV2Colors.p5,
            borderColorHover: pcpV2Colors.p4,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
        secondary: {
            color: pcpV2Colors.p5,
            colorHover: '#144594',
            backgroundColor: 'white',
            // backgroundColorHover: '#e4e6ea',
            backgroundColorHover: pcpV2Colors.comboboxOptionHover,
            border: 'solid 1px',
            borderColor: pcpV2Colors.inputColorBorder,
            borderColorHover: pcpV2Colors.p4,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
        warning: {
            color: pcpV2Colors.warningOrangeText,
            colorHover: pcpV2Colors.warningOrangeText,
            backgroundColor: pcpV2Colors.warningOrange,
            backgroundColorHover: pcpV2Colors.midOrange,
            border: 'none',
            borderColor: pcpV2Colors.warningOrangeBorder,
            borderColorHover: pcpV2Colors.warningOrangeBorder,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
        success: {
            color: 'white',
            colorHover: 'white',
            backgroundColor: pcpV2Colors.successGreen,
            backgroundColorHover: pcpV2Colors.successGreenHover,
            border: 'none',
            borderColor: pcpV2Colors.successGreen,
            borderColorHover: pcpV2Colors.successGreenHover,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
        danger: {
            color: pcpV2Colors.red,
            colorHover: 'white',
            backgroundColor: 'white',
            backgroundColorHover: pcpV2Colors.lightRed,
            border: 'solid 1px transparent',
            borderColor: pcpV2Colors.red,
            borderColorHover: pcpV2Colors.lightRed,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
    },
    badge: {
        pos: {
            color: 'green',
            borderColor: 'green',
        },
        neg: {
            color: 'red',
            borderColor: 'red',
        },
    },
    card: {
        borderRadius: pcpV2Values.cardRadius,
        boxShadow: pcpV2Values.cardBoxShadow,
        boxShadowHover: pcpV2Values.cardBoxShadowHover,
    },
    icon: {
        size: pcpV2Values.iconSize,
        strokeWidth: pcpV2Values.strokeWidth,
        default: {
            color: pcpV2Colors.mainColor,
            backgroundColorHover: pcpV2Colors.iconBackgroundColorHover,
        },
        neg: {
            color: 'red',
            backgroundColorHover: pcpV2Colors.iconBackgroundColorHover,
        },
        passive: {
            color: pcpV2Colors.fontColorGray,
            backgroundColorHover: pcpV2Colors.iconBackgroundColorHover,
        },
    },
    font: {
        alertColor: 'red',
        passiveColor: pcpV2Colors.fontColorGray,
        highlightColor: pcpV2Colors.p5,
        mainColorHover: pcpV2Colors.textBlue,
    },
    navbar: {
        backgroundColor: pcpV2Colors.navbarBackground,
        boxShadow: pcpV2Values.navbarBoxShadow,
    },
    navbutton: {
        default: {
            color: pcpV2Colors.mainColor,
            backgroundColor: 'white',
            backgroundColorHover: pcpV2Colors.lightGray,
            borderColor: 'white',
            borderColorHover: pcpV2Colors.lightGray,
        },
        horizontal: {
            colorActive: pcpV2Colors.mainColor,
            colorInactive: pcpV2Colors.inactiveColor,
            backgroundColorHover: 'white',
        },
        vertical: {
            colorActive: pcpV2Colors.mainColor,
            colorInactive: pcpV2Colors.darkBlue,
            backgroundColorActive: pcpV2Colors.myBlue,
            backgroundColorInactive: 'white',
            backgroundColorHover: pcpV2Colors.lightGray,
            borderColor: 'white',
            borderColorHover: pcpV2Colors.lightGray,
        },
    },
    accordionMenu: {
        backgroundColor: pcpV2Colors.accordionMenuBackground,
    },
    newMessageBadge: {
        backgroundColor: pcpV2Colors.selectButtonActive,
    },
    step: {
        active: pcpV2Colors.activeStep,
        completed: pcpV2Colors.successGreen,
        line: pcpV2Colors.gray_1,
    },
    header: {
        main: {
            backgroundColor: 'white',
            color: 'black',
            buttonColor: pcpV2Colors.mainColor,
        },
    },
    sidebar: {
        backgroundImage: pcpV2Colors.sidebarBackground,
        boxShadow: pcpV2Values.sidebarBoxShadow,
        itemBackground: pcpV2Colors.comboboxOptionActive,
    },
    tabcontainer: {
        backgroundImage: pcpV2Colors.tabContainerBackground,
    },
    modal: {
        borderRadius: pcpV2Values.modalBorderRadius,
        boxShadow: pcpV2Values.modalBoxShadow,
    },
    list: {
        item: {
            backgroundColorHover: pcpV2Colors.comboboxOptionHover,
            colorHover: '#174ea6',
            boxShadow: pcpV2Values.buttonBoxShadow,
            borderColor: pcpV2Colors.inputColorBorder,
        },
    },
    medication: {
        icon: {
            acceptColor: pcpV2Colors.mainColor,
            rejectColor: 'red',
            laterColor: pcpV2Colors.fontColorGray,
            resultAcceptColor: 'green',
        },
    },
    hint: {
        backgroundColor: pcpV2Colors.hintBackground,
    },
    link: {
        color: pcpV2Colors.linkColor,
        colorHover: pcpV2Colors.linkColorHover,
    },
    input: {
        label: pcpV2Colors.inputColorLabel,
        border: pcpV2Colors.inputColorBorder,
        borderFocus: pcpV2Colors.inputColorBorderFocus,
        boxShadowFocus: pcpV2Colors.inputBoxShadowFocus,
    },
    combobox: {
        border: pcpV2Colors.inputColorLabel,
        borderFocus: pcpV2Colors.inputColorBorderFocus,
        boxShadowFocus: pcpV2Colors.inputBoxShadowFocus,
        optionBackgroundHover: pcpV2Colors.selectButtonActive,
        optionBackgroundSelected: pcpV2Colors.comboboxOptionSelected,
        optionBackgroundActive: pcpV2Colors.comboboxOptionActive,
        color: pcpV2Colors.comboboxColor,
        colorHover: pcpV2Colors.comboboxColorHover,
        colorSelected: pcpV2Colors.comboboxColorSelected,
        colorActive: pcpV2Colors.comboboxColorActive,
    },
    calendar: {
        backgroundEven: 'white',
        backgroundOdd: pcpV2Colors.gray_1,
    },
};

/** BETA Theme */
const betaColors = {
    mainColor: '#e99628',
    selectButtonActive: 'rgb(255,189,109)',
    midOrange: '#fbb102',
    primaryColor: '#e99628',
    primaryColorHover: '#ffbd6d',
    warningOrange: '#d39e00', //own color
    warningOrangeBorder: '#c69500', // own color
    warningOrangeText: '#212529', // own color
    successGreen: '#adcf03', //own color
    successGreenHover: '#adcf03c2', //own color
    activeStep: '#fed86e',
    fontColorGray: 'rgba(116,118,130)',
    lightGray: 'rgb(245, 245, 245)',
    inactiveColor: 'gray',
    darkBlue: '#1c3351',
    myBlue: '#d7e3f2',
    textBlue: '#707ea4',
    iconBackgroundColorHover: '#ffbd6d',
    accordionMenuBackground: '#e2e6ea',
    navbarBackground: '#f8f9fa',
    sidebarBackground: 'linear-gradient(to right top, #e99628, #e99628, #e99628, #e99628, #e99628)',
    tabContainerBackground: 'none',
    hintBackground: 'rgb(240, 240, 240)',
};

const betaValues = {
    borderRadius: '4px',
    buttonBorderRadius: '4px',
    buttonBoxShadow: 'none',
    navbarBoxShadow: 'none',
    sidebarBoxShadow: 'none',
    modalBorderRadius: '0px',
    modalBoxShadow: 'none',
    cardBoxShadow: '0 2px 4px 0 #e0e1e1, 0 3px 10px 0 #e0e1e1',
    cardBoxShadowHover: '0 4px 8px 0 #e0e1e1, 0 6px 20px 0 #e0e1e1',
    cardRadius: '10px',
    iconSize: 30,
    strokeWidth: 2,
};

export const betaTheme: DefaultTheme = {
    borderRadius: betaValues.borderRadius,
    mainColor: betaColors.mainColor,
    passiveColor: betaColors.lightGray,
    selectButton: {
        backgroundColor: 'white',
        backgroundColorHover: betaColors.selectButtonActive,
        backgroundColorActive: betaColors.selectButtonActive,
    },
    button: {
        borderRadius: betaValues.buttonBorderRadius,
        boxShadow: betaValues.buttonBoxShadow,
        primary: {
            color: 'white',
            colorHover: 'white',
            backgroundColor: betaColors.primaryColor,
            backgroundColorHover: betaColors.primaryColorHover,
            border: 'solid 1px transparent',
            borderColor: betaColors.primaryColor,
            borderColorHover: betaColors.primaryColorHover,
            borderRadiusTopLeft: betaValues.buttonBorderRadius,
            borderRadiusTopRight: betaValues.buttonBorderRadius,
            borderRadiusBottomLeft: betaValues.buttonBorderRadius,
            borderRadiusBottomRight: betaValues.buttonBorderRadius,
        },
        secondary: {
            color: betaColors.primaryColor,
            colorHover: 'white',
            backgroundColor: 'white',
            backgroundColorHover: betaColors.primaryColorHover,
            border: 'solid 1px transparent',
            borderColor: betaColors.primaryColor,
            borderColorHover: betaColors.primaryColorHover,
            borderRadiusTopLeft: betaValues.buttonBorderRadius,
            borderRadiusTopRight: betaValues.buttonBorderRadius,
            borderRadiusBottomLeft: betaValues.buttonBorderRadius,
            borderRadiusBottomRight: betaValues.buttonBorderRadius,
        },
        warning: {
            color: betaColors.warningOrangeText,
            colorHover: betaColors.warningOrangeText,
            backgroundColor: betaColors.warningOrange,
            backgroundColorHover: betaColors.midOrange,
            border: 'solid 1px transparent',
            borderColor: betaColors.warningOrangeBorder,
            borderColorHover: betaColors.warningOrangeBorder,
            borderRadiusTopLeft: betaValues.buttonBorderRadius,
            borderRadiusTopRight: betaValues.buttonBorderRadius,
            borderRadiusBottomLeft: betaValues.buttonBorderRadius,
            borderRadiusBottomRight: betaValues.buttonBorderRadius,
        },
        success: {
            color: 'white',
            colorHover: 'white',
            backgroundColor: betaColors.successGreen,
            backgroundColorHover: betaColors.successGreenHover,
            border: 'solid 1px transparent',
            borderColor: betaColors.successGreen,
            borderColorHover: betaColors.successGreenHover,
            borderRadiusTopLeft: betaValues.buttonBorderRadius,
            borderRadiusTopRight: betaValues.buttonBorderRadius,
            borderRadiusBottomLeft: betaValues.buttonBorderRadius,
            borderRadiusBottomRight: betaValues.buttonBorderRadius,
        },
        danger: {
            color: pcpV2Colors.red,
            colorHover: 'white',
            backgroundColor: 'white',
            backgroundColorHover: pcpV2Colors.lightRed,
            border: 'solid 1px transparent',
            borderColor: pcpV2Colors.red,
            borderColorHover: pcpV2Colors.lightRed,
            borderRadiusTopLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusTopRight: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomLeft: pcpV2Values.buttonBorderRadius,
            borderRadiusBottomRight: pcpV2Values.buttonBorderRadius,
        },
    },
    badge: {
        pos: {
            color: 'green',
            borderColor: 'green',
        },
        neg: {
            color: 'red',
            borderColor: 'red',
        },
    },
    card: {
        borderRadius: betaValues.cardRadius,
        boxShadow: betaValues.cardBoxShadow,
        boxShadowHover: betaValues.cardBoxShadowHover,
    },
    icon: {
        size: betaValues.iconSize,
        strokeWidth: betaValues.strokeWidth,
        default: {
            color: betaColors.mainColor,
            backgroundColorHover: betaColors.iconBackgroundColorHover,
        },
        neg: {
            color: 'red',
            backgroundColorHover: betaColors.primaryColorHover,
        },
        passive: {
            color: betaColors.fontColorGray,
            backgroundColorHover: betaColors.primaryColorHover,
        },
    },
    font: {
        alertColor: 'red',
        passiveColor: betaColors.fontColorGray,
        highlightColor: betaColors.primaryColor,
        mainColorHover: betaColors.primaryColorHover,
    },
    navbar: {
        backgroundColor: betaColors.navbarBackground,
        boxShadow: betaValues.navbarBoxShadow,
    },
    navbutton: {
        default: {
            color: betaColors.mainColor,
            backgroundColor: 'white',
            backgroundColorHover: betaColors.lightGray,
            borderColor: 'white',
            borderColorHover: betaColors.lightGray,
        },
        horizontal: {
            colorActive: betaColors.mainColor,
            colorInactive: betaColors.inactiveColor,
            backgroundColorHover: 'white',
        },
        vertical: {
            colorActive: betaColors.mainColor,
            colorInactive: betaColors.darkBlue,
            backgroundColorActive: betaColors.myBlue,
            backgroundColorInactive: 'white',
            backgroundColorHover: betaColors.lightGray,
            borderColor: 'white',
            borderColorHover: betaColors.lightGray,
        },
    },
    accordionMenu: {
        backgroundColor: pcpV2Colors.accordionMenuBackground,
    },
    newMessageBadge: {
        backgroundColor: pcpV2Colors.selectButtonActive,
    },
    step: {
        active: betaColors.activeStep,
        completed: betaColors.successGreen,
        line: pcpV2Colors.gray_1,
    },
    header: {
        main: {
            backgroundColor: betaColors.mainColor,
            color: 'white',
            buttonColor: 'white',
        },
    },
    sidebar: {
        backgroundImage: betaColors.sidebarBackground,
        boxShadow: betaValues.sidebarBoxShadow,
        itemBackground: 'transparent',
    },
    tabcontainer: {
        backgroundImage: betaColors.tabContainerBackground,
    },
    modal: {
        borderRadius: betaValues.modalBorderRadius,
        boxShadow: betaValues.modalBoxShadow,
    },
    list: {
        item: {
            backgroundColorHover: betaColors.primaryColorHover,
            colorHover: 'white',
            boxShadow: betaValues.buttonBoxShadow,
            borderColor: pcpV2Colors.inputColorBorder,
        },
    },
    medication: {
        icon: {
            acceptColor: betaColors.mainColor,
            rejectColor: 'red',
            laterColor: betaColors.fontColorGray,
            resultAcceptColor: 'green',
        },
    },
    hint: {
        backgroundColor: betaColors.hintBackground,
    },
    link: {
        color: pcpV2Colors.linkColor,
        colorHover: pcpV2Colors.linkColorHover,
    },
    input: {
        label: pcpV2Colors.inputColorLabel,
        border: pcpV2Colors.inputColorBorder,
        borderFocus: pcpV2Colors.inputColorBorderFocus,
        boxShadowFocus: pcpV2Colors.inputBoxShadowFocus,
    },
    combobox: {
        border: pcpV2Colors.inputColorLabel,
        borderFocus: pcpV2Colors.inputColorBorderFocus,
        boxShadowFocus: pcpV2Colors.inputBoxShadowFocus,
        optionBackgroundHover: pcpV2Colors.comboboxOptionHover,
        optionBackgroundSelected: pcpV2Colors.comboboxOptionSelected,
        optionBackgroundActive: pcpV2Colors.comboboxOptionActive,
        color: pcpV2Colors.comboboxColor,
        colorHover: pcpV2Colors.comboboxColorHover,
        colorSelected: pcpV2Colors.comboboxColorSelected,
        colorActive: pcpV2Colors.comboboxColorActive,
    },
    calendar: {
        backgroundEven: 'white',
        backgroundOdd: pcpV2Colors.gray_1,
    },
};

/* Legacy Themes Compatiblity */
export const pcpTheme = pcpV2Theme;
export const pcpColors = pcpV2Colors;
export const pcpValues = pcpV2Values;
